import React from "react";

import { ContactPersonNameCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function contactPersonName({ width, onResize }: Column.Options) {
	return base(ColumnId.ContactPersonName, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default contactPersonName;
